<div class="modal-body">
  <app-opening-hours-list [openingHours]="openingHours" [entityCode]="entityCode"></app-opening-hours-list>
</div>
<div class="modal-footer">
  <button class="btn btn-default" (click)="modal.close()" type="button">Fermer</button>
</div>
